import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UpdateMyaccountDialogComponent } from './update-myaccount-dialog/update-myaccount-dialog.component';
import { WalletSummaryService } from 'src/app/shared/services/api/wallet-summary.service';
import { WalletSummary } from 'src/app/shared/models/wallet-summary.interface';
import { ProfileService } from 'src/app/shared/services/profile.service';
import { SessionService } from 'src/app/shared/services/session.service';
import { Router, NavigationStart } from '@angular/router';
import { filter } from 'rxjs/operators';
import { phoneNumberValidator, zipCodeValidator } from './custom-validator';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';


const addressSafePattern = /^[a-zA-Z0-9\s#\-\.,/'&]*$/;
const citySafePattern = /^[a-zA-Z\s\-\.']*$/;

@Component({
  selector: 'app-my-account',
  templateUrl: './my-account.component.html',
  styleUrls: ['./my-account.component.scss']
})

export class MyAccountComponent implements OnInit {

  userIniital: string;
  myForm: FormGroup;
  states = ['AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'FL', 'GA', 'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ', 'NM', 'NY', 'NC', 'ND', 'OH', 'OK', 'OR', 'PA', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VT', 'VA', 'WA', 'WV', 'WI', 'WY'];
  walletSummary: WalletSummary | null = null;
  payment: string = "";
  ccHolderName: any = '';
  memberSince: any = '';
  getPhone: string = '';

  displayName: string = "";

  // Sidebar settings
  myAccountActive: boolean = false;
  contactUsActive: boolean = false;
  preferencesActive: boolean = false;
  managePaymentActive: boolean = false;
  autoRedeemActive: boolean = false;
  autoPayActive: boolean = false; // New property for PPI's auto-pay page
  isPPI: boolean = false; // New property to store the session type

  cashEligible = false;
  rewardEligible = false;
  walletRole:string='';


  constructor(
    private fb: FormBuilder,
    private modalService: NgbModal,
    private profileService: ProfileService,
    private walletSummaryService: WalletSummaryService,
    private sessionService: SessionService,
    private router: Router,
    private dialog: MatDialog,
    private cdf: ChangeDetectorRef
  ) {
    this.myForm = this.fb.group({
      phoneNumber: ['', [Validators.required, phoneNumberValidator]],
      email: ['', [Validators.required, Validators.email]],
      streetAddress: ['', [Validators.required, Validators.pattern(addressSafePattern)]], 
      apartment: ['', [Validators.pattern(addressSafePattern)]], 
      city: ['', [Validators.required, Validators.pattern(citySafePattern)]], 
      state: ['', Validators.required],
      zipCode: ['', [Validators.required, zipCodeValidator]]
    });
    this.userIniital = 'YB';
    this.walletRole =JSON.parse(sessionStorage.getItem("WalletRole"));

    // Set correct sidebar settings
    if (this.router?.url == '/my-account') {
      this.myAccountActive = true;
    } else if (this.router?.url == '/preferences' || this.router?.url == '/preferences/manage-payment') {
      this.preferencesActive = true;
      this.managePaymentActive = true;
    } else if (this.router?.url == '/preferences/auto-redeem') {
      this.preferencesActive = true;
      this.autoRedeemActive = true;
    } else if (this.router?.url == '/contact-us') {
      this.contactUsActive = true;
    }

      this.isPPI = this.sessionService.isPPI();
      this.setActiveLinks(this.router.url);
    
        // Subscribe to router events to update the active state on navigation
        this.router.events.pipe(filter((event: any) => event instanceof NavigationStart)).subscribe(
          (event: NavigationStart) => {
            this.setActiveLinks(event.url);
          }
        );
  }

 
onSubmit(): void {
  if (this.myForm.valid) {
    const formData = this.myForm.value;
    const dataToSend = {
      walletID: this.walletSummary?.wallet.walletID,
      walletRole: 'admin',
      phoneNo: formData.phoneNumber,
      email: formData.email,
      streetAddressLine1: formData.streetAddress,
      streetAddressLine2: formData.apartment,
      city: formData.city,
      state: formData.state,
      zip: formData.zipCode,
      sessionID: sessionStorage.getItem("SessionID")
    };

    this.profileService.setCustomerProfile(dataToSend).subscribe({
      next: (response) => {
        // Handle Backend Error
        if (response && response.success === false) {
          console.warn('Backend validation failed:', response.message);
          
          if (response.message.includes('streetAddressLine1')) {
            const control = this.myForm.get('streetAddress');
            control?.setErrors({ serverError: response.message });
            control?.markAsTouched();
          } else if (response.message.includes('streetAddressLine2')) {
            const control = this.myForm.get('apartment');
            control?.setErrors({ serverError: response.message });
            control?.markAsTouched();
          } else if (response.message.includes('city')) { // Add this block for City
            const control = this.myForm.get('city');
            control?.setErrors({ serverError: response.message });
            control?.markAsTouched();
          }  else {
            this.myForm.setErrors({ serverError: response.message });
          }
          
          this.cdf.detectChanges(); // Force UI update for errors
          
        } else {
          // Handle Backend Success - OPEN MODAL HERE
          console.log('Profile updated successfully:', response);
          let config = new MatDialogConfig();
          config.autoFocus = false;
          this.dialog.open(UpdateMyaccountDialogComponent, config);
        }
      },
      error: (error) => {
        console.error('Error updating profile:', error);
      }
    });
  } else {
    this.myForm.markAllAsTouched();
  }
}

ngOnInit(): void {
    this.walletSummaryService.walletSummary$.subscribe(summary => {
      if (summary && summary.wallet) {
        this.walletSummary = summary;
        this.cashEligible = summary.wallet.cashEligible === "True";
        this.rewardEligible = summary.wallet.rewardEligible === "True";
        this.ccHolderName = summary.wallet.payment.ccHolderName;
        this.memberSince = summary.wallet.tcAcceptanceDate;

        this.profileService.getCustomerProfile(summary.wallet.walletID, 'admin').subscribe(profile => {
          if (profile.success) {
            this.myForm.patchValue({
              phoneNumber: profile.phoneNo,
              email: profile.email,
              streetAddress: profile.address.streetAddressLine1,
              apartment: profile.address.streetAddressLine2,
              city: profile.address.city,
              state: profile.address.state,
              zipCode: profile.address.zipCode
            });
            
            // This is the only new line added to force the UI to update
            this.cdf.detectChanges();
          }
        });
      }
    });

    this.sessionService.getDisplayName().subscribe(displayName => {
      this.displayName = displayName;
    });

     this.isPPI = this.sessionService.isPPI();
     this.setActiveLinks(this.router.url);
  }

  loadDisplayName() {
    this.sessionService.getDisplayName().subscribe(displayName => {
      this.displayName = displayName;
    });
  }

   // Consolidated logic for setting active links
  private setActiveLinks(url: string): void {
    this.myAccountActive = url.startsWith('/my-account');
    this.contactUsActive = url.startsWith('/contact-us');
    this.preferencesActive = url.startsWith('/preferences');

    // Reset all preferences sub-items
    this.managePaymentActive = false;
    this.autoRedeemActive = false;
    this.autoPayActive = false;

    if (this.preferencesActive) {
      if (url.startsWith('/preferences/manage-payment')) {
        this.managePaymentActive = true;
      } else if (url.startsWith('/preferences/auto-redeem')) {
        this.autoRedeemActive = true;
      } else if (url.startsWith('/preferences/auto-pay')) { // New check for auto-pay page
        this.autoPayActive = true;
      }
    }
  }
}
